import apiClient from '@u/apiClient'
import Promise from 'lodash-es/_Promise'
import CheckValidatedPersonController from '@/wayfinder/actions/App/Http/Controllers/Person/CheckValidatedPersonController'
import SearchPersonController from '@/wayfinder/actions/App/Http/Controllers/Person/SearchPersonController'

const base_errors = {}
export default {
  async searchForAPerson({ commit }, payload) {
    await apiClient
      .route(
        SearchPersonController.get({ query: { term: payload.filterText } })
      )
      .then(async (response) => {
        await commit('setPersonList', response.data.personList)
      })
      .catch(async (reason) => {
        await console.error('searchForAPerson', reason)
      })
  },

  checkContact({ commit }, payload) {
    commit('auth/setErrors', base_errors, { root: true })
    return new Promise((resolve, reject) => {
      apiClient
        .route(CheckValidatedPersonController.post(), payload)
        .then((response) => {
          resolve(response)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  }
}
